module.exports = __webpack_public_path__ + "img/close-icon.fbd28b8b.png";